import { Component, effect, input, output, signal } from "@angular/core";
import { Answer, Question } from "src/app/models/question";
import { QuizzQuestionComponent } from "../quizz-question/quizz-question.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-chapter-quizz",
  templateUrl: "./chapter-quizz.component.html",
  styles: ``,
  imports: [QuizzQuestionComponent, TranslatePipe],
})
export class ChapterQuizzComponent {
  questions = input.required<Question[]>();

  currentIndex = signal(0);

  answers = signal<Answer[]>([]);

  questionsAnswered = output<{
    answers: Answer[];
  }>();

  hasNoMoreQuestions = output();

  questionAnswered({ answer }: { answer: Answer }) {
    // console.log(`questionAnswered`, answer);

    this.answers.set([...this.answers(), answer]);

    if (this.currentIndex() < this.questions().length) {
      this.currentIndex.set(this.currentIndex() + 1);
    }
  }

  constructor() {
    effect(() => {
      const _ = this.questions();
      this.currentIndex.set(0);
    });
  }

  checkAnswers() {
    this.questionsAnswered.emit({ answers: this.answers() });
  }
}
